import { useEffect, useState } from 'react';
import { isLightImage } from 'src/utils/imageLightness';

export const useImageLightness = (src?: string | null, threshold = 0.82): boolean | null => {
  const [isLight, setIsLight] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!src) {
      setIsLight(null);
      return () => {
        cancelled = true;
      };
    }

    setIsLight(null);
    isLightImage(src, threshold).then((result) => {
      if (!cancelled) {
        setIsLight(result);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [src, threshold]);

  return isLight;
};
